import {SlotStatus} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotStatus';
import {SlotFormula} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotTypes';
import {SlotGlobalKey, SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {Workbook} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/Workbook';
import {SheetId, SlotId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {BaseValue} from '@mintdata/mint-kit/api/values/BaseValue';
import {computed, observable} from 'mobx';

export type SheetName = string;
export type SheetColumnName = string;

export interface IAnySheetSnapshot
{
    id:SheetId;
    name:SheetName;
    columnNames:Array<SheetColumnName>;
}

export abstract class AnySheet
{
    public id:SheetId;

    public workbook:Workbook;

    @observable
    public name:SheetName;

    @observable
    public columnNames:Array<SheetColumnName>;

    public abstract clone():AnySheet;

    public abstract get isCloud():boolean;
}

export abstract class AnySlot
{
    public id:SlotId;

    public sheet:AnySheet;

    public formula:SlotFormula;

    public location:SlotLocation;

    public status:SlotStatus;

    public value:IValue;

    @computed
    public get valueAsString():string
    {
        return this.value ? this.value.toString() : '';
    }

    @computed
    public get containsFrame():boolean
    {
        return this.value && this.value.isFrame;
    }

    @computed
    public get globalKey():SlotGlobalKey
    {
        return this.location.toGlobalKey(this.sheet.id);
    }

    public abstract get isLazy():boolean;

    public abstract get isLive():boolean;

    public abstract get isAccumulative():boolean;

    public abstract get isSimpleValue():boolean;

    public static isSlotEmpty(slot:AnySlot):boolean
    {
        if( !slot )
            return true;

        if( !Type.isInstanceOfIValue(slot.formula) )
            return false;

        return BaseValue.isValueEmpty(slot.formula as IValue);
    }
}
